// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"75":"d363e300","169":"db7c3bd0","379":"d53d89d5","948":"a259e660"}[chunkId] + ".chunk.js";
};